import React, { KeyboardEvent } from 'react';
import Currency from '@components/common/Currrency/Currency';
import styles from '@components/common/Checkbox/MultiLineCheckbox.module.css';
import cn from '@helpers/className';

type Props = {
  checked: boolean;
  id: string;
  label: string;
  onChange: (checked: boolean) => void;
  currency: string;
};

export default function MultiLineCheckbox({
  checked = false,
  id,
  label,
  onChange,
  currency,
}: Props) {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <div
      role="checkbox"
      tabIndex={0}
      className={styles.checkboxWrapper}
      onClick={() => onChange(!checked)}
      onKeyDown={handleKeyDown}
      aria-checked={checked}
    >
      <div
        className={cn({
          'flex-shrink-0 mr-4': true,
          [styles.checkbox]: true,
          [styles.checkedBox]: checked,
        })}
      />

      <label htmlFor={id} className="flex flex-col">
        {label}

        <div className="d:opacity-50">
          {Number(currency) > 0 ? (
            <Currency
              value={currency}
              valueClasses="text-base font-rp-pn-regular leading-22px"
              isoCodeClasses="text-base"
            />
          ) : null}

          {Number(currency) === 0 ? <p className="text-base font-rp-pn-regular">Free</p> : null}
        </div>
      </label>
    </div>
  );
}
